module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result15-0e341959c30231e049b8327aa7319f83.png";